// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goodsin-summary {\n  padding: 15px;\n  text-align: right;\n  font-size: 18px;\n  font-weight: bold;\n  margin-right: 40px;\n  color: red;\n}\n.goodsin-summary label {\n  margin-left: 40px;\n}\n.bairun-dialog-goodsin-table {\n  height: calc(100% - 80px) !important;\n}\n.goods-validday .el-input-group__prepend .el-input {\n  width: 65px !important;\n}", ""]);
// Exports
module.exports = exports;
